import { ContactDropdownTypeEnum } from "ui/components/Dropdown/ContactDropdown/types";

/** Vrste lokacije vozila — moraju odgovarati `VehicleLocationTypes` na backendu. */
export enum VehicleLocationTypeEnum {
  OFFICE = "OFFICE",
  SUPPLIER = "SUPPLIER",
  CLIENT = "CLIENT",
  SERVICE = "SERVICE",
  DAMAGE_REPAIR = "DAMAGE_REPAIR",
  TIRE_CHANGE = "TIRE_CHANGE",
  OTHER = "OTHER",
}

/** Jedna lokacija vozila kroz vrijeme. */
export interface VehicleLocation {
  id: string | null;
  locationType: VehicleLocationTypeEnum | null;
  /** Naziv premještaja koji je upisao korisnik. */
  name: string | null;
  /** Gotov naziv lokacije za prikaz — poslovnica, kontakt ili adresa, ovisno o vrsti. */
  locationName: string | null;
  officeId: string | null;
  officeName: string | null;
  contactId: string | null;
  contactName: string | null;
  addressLine1: string | null;
  addressCity: string | null;
  addressPostalCode: string | null;
  addressCountry: string | null;
  note: string | null;
  /** Vozač koji je vozilo premjestio — vozač tog vozila. */
  driverId: string | null;
  /** Ime vozača za prikaz; iza njega je korisnik aplikacije ili kontakt. */
  driverName: string | null;
  validFrom: Date | null;
  validUntil: Date | null;
  isActive: boolean;
  /** Promjena statusa koja je izazvala premještaj, ako ga je izazvala. */
  vehicleStatusHistoryId: string | null;
  vehicleStatus: string | null;
  created: Date | null;
  userCreatedName: string | null;
}

/** Unos premještaja — dijele ga transfer modal i modal detalja statusa. */
export interface VehicleLocationFormValues {
  locationType: VehicleLocationTypeEnum;
  /** Naziv premještaja — neobavezan, npr. "Isporuka kupcu". */
  name: string | null;
  officeId: string | null;
  contactId: string | null;
  addressLine1: string | null;
  addressCity: string | null;
  addressPostalCode: string | null;
  addressCountry: string | null;
  note: string | null;
  /** Vozač koji je vozilo odvezao — vozač tog vozila. */
  driverId: string | null;
  validFrom: Date | null;
}

/** Konfiguracija prikaza po vrsti lokacije. */
export interface VehicleLocationTypeConfig {
  label: string;
  /** Grupe kontakata koje dropdown nudi za tu vrstu ("S" dobavljač, "B" kupac). */
  contactGroupIds?: string[];
  /**
   * Vrsta kontakta koju vrsta lokacije traži. Prazno = i tvrtka i osoba; servisne vrste
   * traže tvrtku, pa se i unos novog kontakta otvara bez pitanja o tipu.
   */
  contactType?: ContactDropdownTypeEnum;
  /** Predložena vrsta pri unosu novog kontakta, kad je jedna česta ali ne i jedina. */
  defaultContactType?: ContactDropdownTypeEnum;
  /** Naslov polja nositelja lokacije. */
  holderLabel: string;
  /** Ikona u vizualnom izborniku vrste. */
  icon: string;
  /** Objašnjenje uz ikonu — prikazuje se samo gdje ima mjesta. */
  description: string;
}
